import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { zAppDevTabViewComponent } from './tabView.component';
import { ZAppDevTabPanel } from './tabPanel.component';
import { RuleEngineModule } from 'src/app/@framework/rule-engine/rule-engine.module';

const COMPONENTS = [
  zAppDevTabViewComponent,
  ZAppDevTabPanel
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    CommonModule,
    RuleEngineModule,
  ],
  exports: [...COMPONENTS]
})
export class zAppDevTabContainerModule { }
